import { gql } from '@apollo/client';

import { User, Conversation, ConversationMessage } from '../../types';

export interface LatestUnreadConversationMessage {
  latestUnreadConversationMessage: Pick<Conversation, 'uuid'> & {
    conversationMessage: Pick<ConversationMessage, 'content' | 'type'>;
    user: Pick<User, 'firstName'>;
  };
}

export const LATEST_UNREAD_CONVERSATION_MESSAGE = gql`
  query latestUnreadConversationMessage(
    $event_request_id: String
    $supplier_id: String
    $userId: String
  ) {
    latestUnreadConversationMessage(
      eventRequestId: $event_request_id
      supplierId: $supplier_id
      userId: $userId
    ) {
      uuid
      conversationMessage {
        content
        type
      }
      user {
        firstName
      }
    }
  }
`;
